var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isBannerBuilder
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center mt-2 mb-3 flex-wrap" },
            [
              _vm._l(_vm.presets, function (preset, key) {
                return _c(
                  "b-button",
                  {
                    key: key,
                    staticClass: "text-capitalize shadow-preset mb-2",
                    class: [`preset-${key}`],
                    attrs: {
                      variant: `${
                        key === _vm.activePreset ? "" : "outline-"
                      }primary`,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.usePreset(key)
                      },
                    },
                  },
                  [_vm._v("\n      " + _vm._s(key) + "\n    ")]
                )
              }),
              _vm._v(" "),
              _vm.target && _vm.target.text
                ? _c(
                    "b-button",
                    {
                      staticClass: "text-capitalize shadow-preset mb-2",
                      class: [`preset-outline`],
                      attrs: {
                        variant: `${
                          "outline" === _vm.activePreset ? "" : "outline-"
                        }primary`,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.usePreset("outline")
                        },
                      },
                    },
                    [_vm._v("\n      Outline\n    ")]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.selectedShadow === "oval"
            ? [
                _c("OvalShadow", {
                  attrs: {
                    "preset-data": _vm.presets["oval"],
                    target: _vm.target,
                  },
                }),
              ]
            : _vm.selectedShadow === "mirror"
            ? [
                _c("MirrorShadow", {
                  attrs: {
                    "preset-data": _vm.presets["mirror"],
                    target: _vm.target,
                  },
                }),
              ]
            : _vm.selectedShadow === "outline"
            ? [_c("OutlineShadow", { attrs: { target: _vm.target } })]
            : _vm.selectedShadow === "projected"
            ? [
                _c(
                  "b-form-group",
                  { attrs: { label: "Blur" } },
                  [
                    _c(
                      "b-input-group",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("b-input", {
                                    attrs: { max: 100, min: 0, type: "number" },
                                    on: { input: _vm.setShadow },
                                    model: {
                                      value: _vm.blur,
                                      callback: function ($$v) {
                                        _vm.blur = $$v
                                      },
                                      expression: "blur",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1286684811
                        ),
                      },
                      [
                        _c("b-input", {
                          attrs: { max: 100, min: 0, type: "range" },
                          on: { input: _vm.setShadow },
                          model: {
                            value: _vm.blur,
                            callback: function ($$v) {
                              _vm.blur = $$v
                            },
                            expression: "blur",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Intensity" } },
                  [
                    _c(
                      "b-input-group",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("b-input", {
                                    attrs: { max: 100, min: 0, type: "number" },
                                    model: {
                                      value: _vm.intensity,
                                      callback: function ($$v) {
                                        _vm.intensity = $$v
                                      },
                                      expression: "intensity",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3150396340
                        ),
                      },
                      [
                        _c("b-input", {
                          attrs: { max: 100, min: 0, type: "range" },
                          model: {
                            value: _vm.intensity,
                            callback: function ($$v) {
                              _vm.intensity = $$v
                            },
                            expression: "intensity",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Color" } },
                  [
                    _c("ColorPicker", {
                      attrs: {
                        opacity: "",
                        copy: "",
                        position: "right-middle",
                      },
                      on: { input: _vm.setShadow },
                      model: {
                        value: _vm.color,
                        callback: function ($$v) {
                          _vm.color = $$v
                        },
                        expression: "color",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ShadowProjection", {
                  attrs: { target: _vm.target },
                  on: { change: _vm.onProjectionChange },
                }),
              ]
            : [
                _c(
                  "b-form-group",
                  { attrs: { label: "Blur" } },
                  [
                    _c(
                      "b-input-group",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("b-input", {
                                    attrs: { max: 100, min: 0, type: "number" },
                                    on: { input: _vm.setShadow },
                                    model: {
                                      value: _vm.blur,
                                      callback: function ($$v) {
                                        _vm.blur = $$v
                                      },
                                      expression: "blur",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1286684811
                        ),
                      },
                      [
                        _c("b-input", {
                          attrs: { max: 100, min: 0, type: "range" },
                          on: { input: _vm.setShadow },
                          model: {
                            value: _vm.blur,
                            callback: function ($$v) {
                              _vm.blur = $$v
                            },
                            expression: "blur",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Distance" } },
                  [
                    _c(
                      "b-input-group",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("b-input", {
                                    attrs: { max: 200, min: 0, type: "number" },
                                    on: { input: _vm.calculateOffsets },
                                    model: {
                                      value: _vm.distance,
                                      callback: function ($$v) {
                                        _vm.distance = $$v
                                      },
                                      expression: "distance",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2157234556
                        ),
                      },
                      [
                        _c("b-input", {
                          attrs: { max: 200, min: 0, type: "range" },
                          on: { input: _vm.calculateOffsets },
                          model: {
                            value: _vm.distance,
                            callback: function ($$v) {
                              _vm.distance = $$v
                            },
                            expression: "distance",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Angle" } },
                  [
                    _c(
                      "b-input-group",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("b-input", {
                                    attrs: { max: 360, min: 0, type: "number" },
                                    on: { input: _vm.calculateOffsets },
                                    model: {
                                      value: _vm.angle,
                                      callback: function ($$v) {
                                        _vm.angle = $$v
                                      },
                                      expression: "angle",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4223090937
                        ),
                      },
                      [
                        _c("b-input", {
                          attrs: { max: 360, min: 0, type: "range" },
                          on: { input: _vm.calculateOffsets },
                          model: {
                            value: _vm.angle,
                            callback: function ($$v) {
                              _vm.angle = $$v
                            },
                            expression: "angle",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Intensity" } },
                  [
                    _c(
                      "b-input-group",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("b-input", {
                                    attrs: { max: 100, min: 0, type: "number" },
                                    model: {
                                      value: _vm.intensity,
                                      callback: function ($$v) {
                                        _vm.intensity = $$v
                                      },
                                      expression: "intensity",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3150396340
                        ),
                      },
                      [
                        _c("b-input", {
                          attrs: { max: 100, min: 0, type: "range" },
                          model: {
                            value: _vm.intensity,
                            callback: function ($$v) {
                              _vm.intensity = $$v
                            },
                            expression: "intensity",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Color" } },
                  [
                    _c("ColorPicker", {
                      attrs: {
                        opacity: "",
                        copy: "",
                        position: "right-middle",
                      },
                      on: { input: _vm.setShadow },
                      model: {
                        value: _vm.color,
                        callback: function ($$v) {
                          _vm.color = $$v
                        },
                        expression: "color",
                      },
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      )
    : _c(
        "div",
        [
          _c(
            "b-form-group",
            { attrs: { label: "Blur" } },
            [
              _c(
                "b-input-group",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("b-input", {
                            attrs: { max: 100, min: 0, type: "number" },
                            on: { input: _vm.setShadow },
                            model: {
                              value: _vm.blur,
                              callback: function ($$v) {
                                _vm.blur = $$v
                              },
                              expression: "blur",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-input", {
                    attrs: { max: 100, min: 0, type: "range" },
                    on: { input: _vm.setShadow },
                    model: {
                      value: _vm.blur,
                      callback: function ($$v) {
                        _vm.blur = $$v
                      },
                      expression: "blur",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Distance", disabled: _vm.projection.enabled } },
            [
              _c(
                "b-input-group",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("b-input", {
                            attrs: { max: 200, min: 0, type: "number" },
                            on: { input: _vm.calculateOffsets },
                            model: {
                              value: _vm.distance,
                              callback: function ($$v) {
                                _vm.distance = $$v
                              },
                              expression: "distance",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-input", {
                    attrs: { max: 200, min: 0, type: "range" },
                    on: { input: _vm.calculateOffsets },
                    model: {
                      value: _vm.distance,
                      callback: function ($$v) {
                        _vm.distance = $$v
                      },
                      expression: "distance",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Angle", disabled: _vm.projection.enabled } },
            [
              _c(
                "b-input-group",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("b-input", {
                            attrs: { max: 360, min: 0, type: "number" },
                            on: { input: _vm.calculateOffsets },
                            model: {
                              value: _vm.angle,
                              callback: function ($$v) {
                                _vm.angle = $$v
                              },
                              expression: "angle",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-input", {
                    attrs: { max: 360, min: 0, type: "range" },
                    on: { input: _vm.calculateOffsets },
                    model: {
                      value: _vm.angle,
                      callback: function ($$v) {
                        _vm.angle = $$v
                      },
                      expression: "angle",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Intensity" } },
            [
              _c(
                "b-input-group",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("b-input", {
                            attrs: { max: 100, min: 0, type: "number" },
                            model: {
                              value: _vm.intensity,
                              callback: function ($$v) {
                                _vm.intensity = $$v
                              },
                              expression: "intensity",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-input", {
                    attrs: { max: 100, min: 0, type: "range" },
                    model: {
                      value: _vm.intensity,
                      callback: function ($$v) {
                        _vm.intensity = $$v
                      },
                      expression: "intensity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }